const roundedPercentages = function (percentages) {
  const sorted = Object.entries(percentages).sort(function (a, b) {
    if (b[1] - Math.floor(b[1]) > a[1] - Math.floor(a[1])) {
      return 1;
    } else {
      return -1;
    }
  });

  let floored = sorted.map((n) => {
    const floor = n[1] < 0 ? 0 : Math.floor(n[1]);

    return [n[0], floor];
  });

  const sum = floored.map((n) => n[1]).reduce((a, b) => a + b);
  const diff = 100 - sum;

  if (diff <= floored.length) {
    for (let index = 0; index < diff; index++) {
      floored[index][1]++;
    }
  }

  let rounded = {};

  floored.forEach((n) => {
    rounded[n[0]] = n[1];
  });

  return rounded;
};

export default roundedPercentages;
